<div class="page">
  <!-- Photo cover from the CMS (FORUMS_HEADER_OPTIONS.html, option A). -->
  <section class="hero" [class.hero--with-featured]="hasFeatured" aria-labelledby="forumsTitle"
           [style.--hero-cover]="cover(headerData?.coverBg?.large, '/utest-static/assets/images/hero/discussions-bg.jpg')"
           [style.--hero-cover-preview]="cover(headerData?.coverBg?.small, '/utest-static/assets/images/hero/discussions-bg-xs.jpg')">
    @if (category) {
      <a class="back-link" uiSref="forums">
        <span class="material-icons" aria-hidden="true">arrow_back</span>
        Forums
      </a>
      <h1 class="hero__title" id="forumsTitle">{{ category.parent ? category.parent.name + ': ' : '' }}{{ category.name }}</h1>
      @if (category.description) {
        <p class="hero__desc">{{ category.description }}</p>
      }
    } @else {
      <h1 class="hero__title" id="forumsTitle">{{ headerData?.title }}</h1>
      <p class="hero__desc" [innerHTML]="headerData?.description"></p>
    }
    @if (category ? user : canCreate) {
      <div class="hero__actions">
        <a class="ut-btn forums__new" [href]="newDiscussionHref" (click)="newDiscussion($event)">
          <span class="material-icons" aria-hidden="true">add</span>
          Create a new topic
        </a>
      </div>
    }
  </section>

  @if (hasFeatured) {
    <section class="hero-featured" aria-labelledby="featuredTopics">
      <h2 class="sr-only" id="featuredTopics">Featured topics</h2>
      <ul class="featured">
        @for (topic of featured.slice(0, 2); track topic.id) {
          <li class="featured__card">
            <ng-container *ngTemplateOutlet="byline; context: { $implicit: topic }"></ng-container>
            <a class="featured__title" uiSref="singlediscussionpage" [uiParams]="{ page: 1, discussionId: topic.id }" [innerHTML]="topic.title | emojiHtml"></a>
            @if (topic.category) {
              <span class="featured__meta">
                <ut-category-link [category]="topic.category"></ut-category-link>
              </span>
            }
            @if (preview(topic)) {
              <p class="featured__excerpt" [innerHTML]="preview(topic)"></p>
            }
            <span class="featured__foot topic__stats">
              <ng-container *ngTemplateOutlet="stats; context: { $implicit: topic }"></ng-container>
            </span>
          </li>
        }
      </ul>
    </section>
  }

  <div class="forums__main">
    @if (!category) {
      <div class="forums__filter">
        <label class="forums__select-label">
          <span class="sr-only">Category</span>
          <select class="select select--sm forums__select" (change)="filterBy(+$any($event.target).value || null)">
            <option value="" [selected]="!categoryId">All categories</option>
            @for (cat of categories(); track cat.id) {
              <option [value]="cat.id" [selected]="cat.id === categoryId">{{ cat.displayName }}</option>
            }
          </select>
        </label>
      </div>

      <nav class="tabs" aria-label="Sort topics">
        @for (option of tabs; track option.value) {
          <a
            class="tab"
            [id]="'forumsTab_' + option.value"
            [class.is-active]="tab === option.value"
            [attr.aria-current]="tab === option.value ? 'page' : null"
            uiSref="forums"
            [uiParams]="{ tab: option.value, topic_page: 1, category_id: categoryId }">{{ option.label }}</a>
        }
      </nav>
    }

    <p class="sr-only" role="status">{{ status }}</p>
    @if (rows; as topics) {
      @if (topics.length) {
        <ul class="card topics" aria-label="Topics">
          @for (topic of topics; track topic.id) {
            <li class="topic" [class.is-sticky]="topic.sticky">
              <div class="topic__main">
                <ng-container *ngTemplateOutlet="byline; context: { $implicit: topic }"></ng-container>
                <div class="topic__title-line">
                  <a class="topic__title" [id]="'topic_' + topic.id" uiSref="singlediscussionpage" [uiParams]="{ page: 1, discussionId: topic.id }" [innerHTML]="topic.title | emojiHtml"></a>
                  @if (topic.sticky) {
                    <span class="badge badge--brand"><span class="material-icons" aria-hidden="true">bookmark</span>Pinned</span>
                  }
                  @if (topic.locked) {
                    <span class="badge"><span class="material-icons" aria-hidden="true">lock</span>Locked</span>
                  }
                  @if (topic.state === 'hidden') {
                    <span class="badge badge--error"><span class="material-icons" aria-hidden="true">visibility_off</span>Hidden</span>
                  }
                </div>
                @if (topic.category && !category) {
                  <p class="topic__meta">
                    <ut-category-link [category]="topic.category"></ut-category-link>
                  </p>
                }
              </div>
              <div class="topic__side">
                <p class="topic__when">
                  @if (replyCount(topic)) {
                    Last reply {{ (topic.last_commented_at || topic.published_at) | relativeDate }}
                  } @else {
                    No replies yet
                  }
                </p>
              </div>
              <!-- Its own row, so the text runs the card's full width under the last reply. -->
              @if (preview(topic)) {
                <p class="topic__excerpt" [innerHTML]="preview(topic)"></p>
              }
              <div class="topic__stats topic__foot">
                <ng-container *ngTemplateOutlet="stats; context: { $implicit: topic, actions: true }"></ng-container>
              </div>
            </li>
          }
        </ul>
      } @else if (!failed() && !store?.failed) {
        <div class="card empty">
          <span class="empty__icon" aria-hidden="true"><span class="material-icons">forum</span></span>
          <p class="empty__title">No topics here yet</p>
          <p class="empty__text">Start the conversation with a new topic.</p>
        </div>
      }
    } @else {
      <!-- Placeholder rows in the same shape as the topic list. -->
      <ul class="card topics topics--loading" aria-hidden="true">
        @for (width of loadingRows; track $index) {
          <li class="topic">
            <span class="topic__main">
              <span class="byline">
                <span class="ph ph--avatar"></span>
                <span class="ph ph--meta"></span>
              </span>
              <span class="ph ph--title" [style.width.%]="width"></span>
              <span class="ph ph--meta"></span>
            </span>
            <span class="topic__side">
              <span class="ph ph--when"></span>
            </span>
            <span class="topic__foot">
              <span class="ph ph--stats"></span>
            </span>
          </li>
        }
      </ul>
    }

    @if (failed() || store?.failed) {
      <div class="alert alert--error" role="alert">
        <span class="material-icons" aria-hidden="true">error_outline</span>
        <p class="alert__text"><b>Topics couldn't load.</b> Check your connection and try again.</p>
        <button type="button" class="ut-btn ut-btn--secondary ut-btn--sm" (click)="category ? loadMore() : loadPage()">Retry</button>
      </div>
    }

    @if (category) {
      @if (store.feedItems.length && !store.isLastPage && !store.failed) {
        <button type="button" class="ut-btn ut-btn--secondary more" [disabled]="store.isLoading" (click)="loadMore()">
          {{ store.isLoading ? 'Loading…' : 'View more' }}
        </button>
      }
    } @else if (totalPages > 1) {
      <nav class="pager" aria-label="Topic pages">
        @if (page > 1) {
          <a id="topicsPrevious" class="pager__step" aria-label="Previous page" uiSref="forums" [uiParams]="{ tab: tab, topic_page: page - 1, category_id: categoryId }" (click)="markPaged()"><span class="material-icons" aria-hidden="true">arrow_back</span><span class="pager__label">Previous</span></a>
        }
        <ul class="pager__pages">
          @for (n of pages; track n) {
            <li>
              <a
                class="pager__page"
                [attr.aria-current]="n === page ? 'page' : null"
                [attr.aria-label]="'Page ' + n"
                [id]="'topicsPage_' + n"
                (click)="markPaged()"
                uiSref="forums"
                [uiParams]="{ tab: tab, topic_page: n, category_id: categoryId }">{{ n }}</a>
            </li>
          }
        </ul>
        @if (page < totalPages) {
          <a id="topicsNext" class="pager__step pager__step--next" aria-label="Next page" uiSref="forums" [uiParams]="{ tab: tab, topic_page: page + 1, category_id: categoryId }" (click)="markPaged()"><span class="pager__label">Next</span><span class="material-icons" aria-hidden="true">arrow_forward</span></a>
        }
      </nav>
    }
  </div>
</div>

<!-- Avatar and name link to the author; the date, a sibling, is the topic's permalink (as in the community feed). -->
<ng-template #byline let-topic>
  <span class="byline">
    @if (topic.user?.slug) {
      <a class="byline__author" uiSref="profile.about" [uiParams]="{ profileId: topic.user.slug }">
        <ng-container *ngTemplateOutlet="author; context: { $implicit: topic }"></ng-container>
      </a>
    } @else {
      <span class="byline__author">
        <ng-container *ngTemplateOutlet="author; context: { $implicit: topic }"></ng-container>
      </span>
    }
    <a class="byline__when" uiSref="singlediscussionpage" [uiParams]="{ page: 1, discussionId: topic.id }">{{ topic.published_at | relativeDate }}<span class="sr-only">, open topic {{ topic.title | emojiText }}</span></a>
  </span>
</ng-template>

<ng-template #author let-topic>
  <ut-avatar-badges class="byline__avatar" [user]="topic.user" aria-hidden="true"></ut-avatar-badges>
  <span class="byline__name">{{ topic.user?.name }}</span>
</ng-template>

<!-- Replies open the topic (filled once you have replied); the heart likes it and its count lists who liked it, as the
     legacy forums' buttons do. Moderator and report actions are only on the index rows (`actions`). -->
<ng-template #stats let-topic let-actions="actions">
  <a class="topic__stat" [class.is-commented]="topic.comments?.commented_by_current_user" uiSref="singlediscussionpage" [uiParams]="{ page: 1, discussionId: topic.id }"
     [attr.aria-label]="replyCount(topic) + (replyCount(topic) === 1 ? ' reply' : ' replies') + (topic.comments?.commented_by_current_user ? ', you replied' : '')">
    <span class="material-icons" aria-hidden="true">{{ topic.comments?.commented_by_current_user ? 'chat_bubble' : 'chat_bubble_outline' }}</span>{{ replyCount(topic) }}
  </a>
  <span class="topic__likes">
    <button type="button" class="topic__stat topic__stat--icon" [class.is-liked]="topic.likes?.liked_by_current_user"
            [disabled]="!topic.current_user_permissions?.like"
            [attr.aria-pressed]="!!topic.likes?.liked_by_current_user"
            aria-label="Like"
            (click)="toggleLike(topic)">
      <span class="material-icons" aria-hidden="true">{{ topic.likes?.liked_by_current_user ? 'favorite' : 'favorite_border' }}</span>
    </button>
    <button type="button" class="topic__stat topic__stat--count" [disabled]="!topic.likes?.count"
            [attr.aria-label]="(topic.likes?.count || 0) + ((topic.likes?.count || 0) === 1 ? ' like' : ' likes') + ', show who liked this'"
            (click)="showLikes(topic)">{{ topic.likes?.count || 0 }}</button>
  </span>
  @if (actions) {
    <span class="topic__actions">
      @if (topic.current_user_permissions?.hide) {
        <ut-community-hide-action [item]="topic" (stateChanged)="cdr.markForCheck()"></ut-community-hide-action>
      }
      @if (canReport(topic)) {
        <ut-community-report-action [item]="topic"></ut-community-report-action>
      }
    </span>
  }
</ng-template>
